import store from '../../../store'
import featureFlags from '../../../config/featureFlags'
import { isGurudwaraAdminPortal } from '@/utils/portalGurudwara'

const locationHostName = window.location.hostname
const isArtistPortal = locationHostName.includes('artist')
const isGurudwaraPortal = isGurudwaraAdminPortal(locationHostName)
const isOrgPortal = locationHostName.includes('organization')
const isHotelPortal = locationHostName.includes('myhotel')

// Helper to determine if we are in the "main" portal
const isMainPortal = !isArtistPortal && !isGurudwaraPortal && !isOrgPortal && !isHotelPortal

const shouldShowHotelModule = isHotelPortal || isMainPortal

const menuItems = [
  // dashboard
  {
    url: null,
    header: 'Dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon',
    roles: ['admin', 'superadmin', 'hotel-manager'],
    items: [
      {
        url: null,
        name: 'Dashboard',
        slug: 'dashboard',
        icon: 'HomeIcon',
        roles: ['admin', 'superadmin', 'hotel-manager'],
        submenu: [
          ...(isGurudwaraPortal || isMainPortal ? [
            {
              url: '/sarai-dashboard',
              name: 'Sarai Dashboard',
              slug: 'SaraiDashboard',
              icon: 'LayersIcon',
              roles: ['admin', 'superadmin']
            }
          ] : []),
          ...(shouldShowHotelModule ? [
            {
              url: '/hotel-dashboard',
              name: 'Hotel Dashboard',
              slug: 'HotelDashboard',
              icon: 'LayersIcon',
              roles: ['superadmin', 'hotel-manager', 'admin']
            }
          ] : []),
          {
            url: '/',
            name: 'Main Dashboard',
            slug: 'MainDashboard',
            icon: 'BarChartIcon',
            roles: ['admin', 'superadmin']
          }
        ]
      }
    ]
  }
]

/** Hotel Module */
if (shouldShowHotelModule) {
  menuItems.push(
    {
      url: '/hotel/list',
      name: 'Hotels',
      slug: 'HotelList',
      icon: 'DatabaseIcon',
      roles: ['admin', 'superadmin', 'hotel-manager']
    },
    // {
    //   url: '/hotel/bookings',
    //   name: 'Bookings',
    //   slug: 'HotelBookings',
    //   icon: 'CheckSquareIcon',
    //   roles: ['admin', 'superadmin', 'hotel-manager']
    // }
  )
}

/** User Management - Common for all portals context except hotel? */
if (!isHotelPortal) {
  menuItems.push({
    url: '/user/list',
    name: 'User List',
    slug: 'userList',
    icon: 'UsersIcon',
    permissions: ['user_list']
  })
}

if (isArtistPortal) {
  menuItems.push(
    {
      url: '/creator/list',
      name: 'Creators',
      slug: 'creatorList',
      icon: 'SpeakerIcon',
      permissions: ['creator_list']
    },
    {
      url: '/audio/list',
      name: 'Audios',
      slug: 'AudioList',
      icon: 'MusicIcon',
      permissions: ['audio_list']
    },
    {
      url: '/playlist/list',
      name: 'Playlist',
      slug: 'PlayList',
      icon: 'PlayCircleIcon',
      permissions: ['playlist_list']
    },
    {
      url: '/video/list',
      name: 'Videos',
      slug: 'VideoList',
      icon: 'YoutubeIcon',
      permissions: ['video_list']
    }
  )
} else if (isGurudwaraPortal) {
  menuItems.push(
    {
      url: '/gurudwara/list',
      name: 'Gurudwaras',
      slug: 'GurudwaraList',
      icon: 'ListIcon',
      permissions: ['gurudwara_list']
    },
    {
      url: '/guide-tutorial/list',
      name: 'Guide Tutorial',
      slug: 'guideTutorialList',
      icon: 'HelpCircleIcon',
      permissions: ['guide_tutorial_list']
    },
    {
      url: '/gurudwara-onboard/list',
      name: 'Gurudwara Onboard',
      slug: 'GurudwaraOnboardList',
      icon: 'SendIcon',
      permissions: ['gurudwara_onboard_list']
    }
  )
} else if (isOrgPortal) {
  menuItems.push(
    {
      url: '/organization/list',
      name: 'Organization',
      slug: 'OrganizationList',
      icon: 'ListIcon',
      permissions: ['organization_list']
    },
    {
      url: '/organization/guide-tutorial/list',
      name: 'Guide Tutorial',
      slug: 'OrgGuideTutorialList',
      icon: 'HelpCircleIcon',
      permissions: ['guide_tutorial_list']
    },
    {
      url: '/organization-onboard/list',
      name: 'Organization Onboard',
      slug: 'OrganizationOnboardList',
      icon: 'SendIcon',
      permissions: ['organization_onboard_list']
    }
  )
} else if (isHotelPortal) {
  // Only hotel items already added
} else if (localStorage.getItem('roleSlug') === 'hotel-manager') {
  // If user is a hotel-manager, don't show main portal items even if on main portal (e.g. localhost)
} else {
  // Main Admin Portal - Show Everything
  menuItems.push({
    url: null,
    permissions: ['creator_list', 'audio_list', 'playlist_list', 'video_list'],
    header: 'Creators Mgmt',
    slug: 'creators',
    icon: 'UserIcon',
    items: [
      {
        url: null,
        name: 'Creators',
        slug: 'students',
        icon: 'UserIcon',
        permissions: ['creator_list', 'audio_list', 'playlist_list', 'video_list'],
        submenu: [
          { url: '/creator/list', name: 'Creators', slug: 'creatorList', icon: 'SpeakerIcon', permissions: ['creator_list'] },
          { url: '/audio/list', name: 'Audios', slug: 'AudioList', icon: 'MusicIcon', permissions: ['audio_list'] },
          { url: '/playlist/list', name: 'Playlist', slug: 'PlayList', icon: 'PlayCircleIcon', permissions: ['playlist_list'] },
          { url: '/video/list', name: 'Videos', slug: 'VideoList', icon: 'YoutubeIcon', permissions: ['video_list'] }
        ]
      }
    ]
  })

  menuItems.push({
    url: null,
    header: 'Gurudwara Mgmt',
    slug: 'gurudwara',
    icon: 'UserIcon',
    permissions: ['gurudwara_list', 'guide_tutorial_list', 'gurudwara_onboard_list'],
    items: [
      {
        url: null,
        name: 'Gurudwara',
        slug: 'gurudwara',
        icon: 'DatabaseIcon',
        permissions: ['gurudwara_list', 'guide_tutorial_list', 'gurudwara_onboard_list'],
        submenu: [
          { url: '/gurudwara/list', name: 'Gurudwaras', slug: 'GurudwaraList', icon: 'ListIcon', permissions: ['gurudwara_list'] },
          { url: '/guide-tutorial/list', name: 'Guide Tutorial', slug: 'guideTutorialList', icon: 'HelpCircleIcon', permissions: ['guide_tutorial_list'] },
          { url: '/gurudwara-onboard/list', name: 'Gurudwara Onboard', slug: 'GurudwaraOnboardList', icon: 'SendIcon', permissions: ['gurudwara_onboard_list'] }
        ]
      }
    ]
  })

  menuItems.push({
    url: null,
    header: 'Organization Mgmt',
    slug: 'organization',
    icon: 'UserIcon',
    permissions: ['organization_list', 'guide_tutorial_list', 'organization_onboard_list'],
    items: [
      {
        url: null,
        name: 'Organization',
        slug: 'organization',
        icon: 'SettingsIcon',
        permissions: ['organization_list', 'guide_tutorial_list', 'organization_onboard_list'],
        submenu: [
          { url: '/organization/list', name: 'Organizations', slug: 'OrganizationList', icon: 'ListIcon', permissions: ['organization_list'] },
          { url: '/organization/guide-tutorial/list', name: 'Guide Tutorial', slug: 'OrgGuideTutorialList', icon: 'HelpCircleIcon', permissions: ['guide_tutorial_list'] }
        ]
      }
    ]
  })

  menuItems.push(
    { url: '/mantra/add', name: 'Mantra', slug: 'MantraList', icon: 'Volume2Icon', permissions: ['mantra_edit'] },
    { url: '/book/list', name: 'Book Mgmt', slug: 'BookList', icon: 'BookOpenIcon', permissions: ['book_list'] },
    { url: '/committee/list', name: 'Committee List', slug: 'committeeList', permissions: ['committee_view'], icon: 'AwardIcon' },
    { url: '/services/list', name: 'Services List', slug: 'servicesList', permissions: ['service_view'], icon: 'VoicemailIcon' },
    ...(featureFlags.enableSubscriptions
      ? [{ url: '/subscription-plan/list', name: 'Subscription Plan', slug: 'subscriptionPlan', icon: 'DatabaseIcon', roles: 'admin' }]
      : []),
    { url: '/feedback/list', name: 'Feedback', slug: 'feedback', permissions: ['feedback_list'], icon: 'ThumbsUpIcon' },
    { url: '/restricted-keyword/add', name: 'Restricted Keyword', slug: 'restrictedKeyword', icon: 'LockIcon', roles: 'admin' },
    { url: '/leadership/list', name: 'Our Leadership', slug: 'leadershipList', icon: 'AwardIcon', roles: 'admin' },
    ...(featureFlags.enableSubscriptions
      ? [{ url: '/premium-offer/add', name: 'Premium Offer', slug: 'premiumOffer', icon: 'GiftIcon', roles: 'admin' }]
      : []),
    { url: '/punjabi-letter/list', name: 'Punjabi Letter', slug: 'LetterList', icon: 'TypeIcon', permissions: ['learning_mode_list', 'month_management_list'] },
    {
      url: null,
      header: 'Admin Setting',
      slug: 'Admin Setting',
      icon: 'SettingsIcon',
      permissions: ['role_list', 'month_management_list', 'notification_send'],
      items: [
        {
          url: null,
          name: 'Admin Setting',
          slug: 'Admin Setting',
          icon: 'ToolIcon',
          permissions: ['role_list', 'month_management_list'],
          submenu: [
            { url: '/notification', name: 'Notification Send', slug: 'NotificationSend', icon: 'BellIcon', permissions: ['notification_send'] },
            { url: '/setting/list', name: 'Policy & About', slug: 'SettingList', icon: 'TypeIcon', permissions: ['role_list'] },
            { url: '/roles-list', name: 'Role & Permission', slug: 'RolesList', icon: 'UserCheckIcon', permissions: ['role_list'] },
            { url: '/month/list', name: 'Months Mgmt', slug: 'monthList', icon: 'CalendarIcon', permissions: ['month_management_list'] },
            { url: '/setting/hotel-amenities', name: 'Hotel Amenities', slug: 'HotelAmenitiesSetting', icon: 'HomeIcon', roles: 'admin' }
          ]
        }
      ]
    },
    /** Search History */
    {
      url: '/search-history/list',
      name: 'Search History',
      slug: 'searchHistory',
      icon: 'SearchIcon',
      roles: 'admin'
    }
  )
}

export default menuItems
